var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import * as zIndex from '@tencent/exeditor3-ui-kit/dist/zIndex.js';
import '@tencent/exeditor3-ui-kit/dist/modal.js';
import { getValidLink } from './utils.js';
const styles = css `
  :host {
    z-index: ${zIndex.modalBackdrop};
  }
  .title {
    font-weight: bold;
  }
  .row {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 20px;
  }
  .row-action {
    justify-content: end;
    flex-direction: row-reverse;
  }
  .label {
    align-self: flex-start;
    display: flex;
    align-items: center;
    min-width: 74px;
    height: 32px;
    margin-right: 10px;
  }
  .value {
    flex: 1;
  }
  .tip {
    margin-top: 5px;
    color: red;
  }

  .input {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    height: 32px;
    margin: 0;
    padding: 5px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    appearance: none;
  }
  .btn {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 88px;
    height: 32px;
    margin-left: 16px;
    border: 0 none;
    border-radius: 4px;
    cursor: pointer;
  }
  .btn-submit {
    color: #fff;
    background-color: #1e6fff;
  }
  .btn-submit:hover {
    background-color: #175ceb;
  }
  .btn-cancel {
    color: #222;
    background-color: #e9ebed;
  }
  .btn-cancel:hover {
    background-color: #d6d8da;
  }
`;
let ExEditorLinkModal = class ExEditorLinkModal extends LitElement {
    constructor() {
        super(...arguments);
        this.linkError = false;
        this.title = '';
        this.text = '';
        this.link = '';
        this.target = '';
        this.t = (token, fallback) => fallback !== null && fallback !== void 0 ? fallback : token;
    }
    handleCancel() {
        this.modal.close();
    }
    handleSubmit() {
        const validLink = getValidLink(this.linkInput.value.trim());
        if (!validLink) {
            this.linkError = true;
            return;
        }
        const data = {
            text: this.textInput.value,
            link: validLink,
            target: this.targetInput.checked ? '_blank' : '',
        };
        const event = new CustomEvent('submit', {
            detail: data,
        });
        this.dispatchEvent(event);
        this.modal.close();
    }
    handleChange() {
        const link = this.linkInput.value.trim();
        if (getValidLink(link)) {
            this.linkError = false;
        }
    }
    handleKeydown(event) {
        const { key, isComposing } = event;
        if (key === 'Enter' && !isComposing) {
            event.preventDefault();
            this.handleSubmit();
        }
    }
    connectedCallback() {
        super.connectedCallback();
        setTimeout(() => {
            if (this.text) {
                this.linkInput.select();
            }
            else {
                this.textInput.focus();
            }
        }, 100);
    }
    render() {
        const { t } = this;
        return html `
      <exeditor-modal>
        <span slot="title" class="title">${this.title}</span>
        <div slot="content">
          <section class="form">
            <div class="row">
              <label class="label">${t('显示文本')}</label>
              <div class="value">
                <input
                  class="input"
                  name="text"
                  value="${this.text}"
                  placeholder="${t('请输入显示文本')}"
                  @keydown=${this.handleKeydown}
                />
              </div>
            </div>

            <div class="row">
              <label class="label">${t('链接')}</label>
              <div class="value">
                <input
                  class="input"
                  name="link"
                  value="${this.link}"
                  placeholder="${t('请输入网页链接地址')}"
                  @input=${this.handleChange}
                  @keydown=${this.handleKeydown}
                />
                ${this.linkError
            ? html ` <div class="tip">${t('请输入有效链接')}</div> `
            : null}
              </div>
            </div>

            <div class="row">
              <label class="label">${t('新标签打开')}</label>
              <input
                type="checkbox"
                name="target"
                .checked=${this.target === '_blank'}
              />
            </div>

            <div class="row row-action">
              <button
                class="btn
                btn-submit"
                type="button"
                @click=${this.handleSubmit}
              >
                ${t('确定')}
              </button>
              <button
                class="btn btn-cancel"
                type="button"
                @click=${this.handleCancel}
              >
                ${t('取消')}
              </button>
            </div>
          </section>
        </div>
      </exeditor-modal>
    `;
    }
};
ExEditorLinkModal.styles = styles;
__decorate([
    state()
], ExEditorLinkModal.prototype, "linkError", void 0);
__decorate([
    query('exeditor-modal')
], ExEditorLinkModal.prototype, "modal", void 0);
__decorate([
    query('[name=text]')
], ExEditorLinkModal.prototype, "textInput", void 0);
__decorate([
    query('[name=link]')
], ExEditorLinkModal.prototype, "linkInput", void 0);
__decorate([
    query('[name=target]')
], ExEditorLinkModal.prototype, "targetInput", void 0);
__decorate([
    property({ attribute: true })
], ExEditorLinkModal.prototype, "title", void 0);
__decorate([
    property({ attribute: true })
], ExEditorLinkModal.prototype, "text", void 0);
__decorate([
    property({ attribute: true })
], ExEditorLinkModal.prototype, "link", void 0);
__decorate([
    property({ attribute: true })
], ExEditorLinkModal.prototype, "target", void 0);
__decorate([
    property()
], ExEditorLinkModal.prototype, "t", void 0);
ExEditorLinkModal = __decorate([
    customElement('exeditor-link-modal')
], ExEditorLinkModal);
export { ExEditorLinkModal };
//# sourceMappingURL=link-modal.js.map